<template>
  <v-container fluid>
    <!-- UsersToken.UserBranch == "company" -->
    <HQHome v-if="UserInfo && UserInfo.UserBranch == 'company'"></HQHome>
    <ProductsComp
      :User="UserInfo"
      v-else-if="UserInfo && UserInfo.UserBranch !== 'company'"
    ></ProductsComp>
  </v-container>
</template>

<script>
// @ is an alias to /src
import HQHome from "@/components/HQ/Dash/HQhome.vue";
import { tokenMixin } from "@/Mixins/tokenMixins.js";

export default {
  name: "Home",
  mixins: [tokenMixin],
  components: {
    HQHome,
    ProductsComp: () => import("@/components/Branches/Products"),
  },
};
</script>
